<template>
  <div class="wrapper height100">
    <v-container fluid class="height100">
      <div class="py-8 my-4">
        <p><b>{{ t('noEmailVerified.title') }}</b></p>
        <br />
        <p>{{ t('noEmailVerified.description') }}</p>
        <table>
          <tbody>
            <tr>
              <td style="vertical-align: top;">１．</td>
              <td style="vertical-align: top;">{{ t('noEmailVerified.step1') }}</td>
            </tr>
            <tr>
              <td style="vertical-align: top;">２．</td>
              <td style="vertical-align: top;">{{ t('noEmailVerified.step2') }}</td>
            </tr>
            <tr>
              <td style="vertical-align: top;">３．</td>
              <td style="vertical-align: top;">{{ t('noEmailVerified.step3') }}</td>
            </tr>
            <tr>
              <td style="vertical-align: top;">４．</td>
              <td style="vertical-align: top;">{{ t('noEmailVerified.step4') }}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <p><b>{{ t('noEmailVerified.noEmailTitle') }}</b></p>
        <p>{{ t('noEmailVerified.noEmailDescription') }}</p>
      </div>
      <div class="d-flex justify-center my-5">
        <v-btn @click="reSignIn" color="primary" block>{{ t('noEmailVerified.loginButton') }}</v-btn>
      </div>
      <div>
        <v-btn @click="logout" color="primary" outlined block>{{ t('noEmailVerified.reLoginButton') }}</v-btn>
      </div>
    </v-container>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { t } from '@/i18n';
import { auth0Module } from '@/store/entityModules/auth0';

export default defineComponent({
  setup() {
    return { t };
  },
  methods: {
    async reSignIn() {
      await auth0Module.signinProcess();
    },
    logout() {
      auth0Module.logout();
    },
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: calc(env(safe-area-inset-top));
    margin-bottom: calc(env(safe-area-inset-bottom));
  }
}
</style>
